import data from '../data/pages.json';
import { Page } from './models';

export function getPages(
  isAuthenticated: boolean,
  hasApprovalFlowEnabled: boolean,
  hasSelfServiceEnabled: boolean,
): Page[] {
  return (data as Page[])
    .filter(page => page?.authenticated === isAuthenticated || page.authenticated === undefined)
    .filter(page => (page.title === 'Approvals' ? hasApprovalFlowEnabled : true))
    .filter(page => (page.title === 'Self Service' ? hasSelfServiceEnabled : true));
}
